import { createFileRoute } from '@tanstack/react-router'
import { QuickBooksIntegrationPage } from '@/components/integrations/QuickBooksIntegrationPage'

export const Route = createFileRoute('/_app/integrations/quickbooks')({
    component: QuickBooksIntegrationPage,
})
